<template>
  <section class="viewsrhqyBasicManage_companyPoundSystemConfig p-4 h-full box-border overflow-y-auto">
    <viewTitle title="业务管理 / 基础数据管理 / 地磅系统配置" :showReturn="false" />
    <el-form ref="form" class="mt-4" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="配置名称" prop="name">
        <el-input class="w-96" clearable placeholder="请输入配置名称" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="接口地址" prop="host">
        <el-input class="w-96" clearable placeholder="请输入接口地址，不对接可留空" v-model="form.host"></el-input>
      </el-form-item>
      <el-form-item label="密钥" prop="userpass">
        <el-input class="w-96" clearable placeholder="请输入密钥，留空则不修改" v-model="form.userpass"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="userid">
        <el-input class="w-96" clearable placeholder="请输入账号" v-model="form.userid"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input class="w-96" type="textarea" :rows="3" placeholder="请输入备注" v-model="form.remark"></el-input>
      </el-form-item>
      <el-form-item label="最后修改人">
        <span class="text-gray-600">{{ form.update_by_name || '-' }}</span>
      </el-form-item>
      <el-form-item label="最后修改时间">
        <span class="text-gray-600">{{ formatTime(form.update_time) }}</span>
      </el-form-item>
    </el-form>
    <div style="height: 56px;"></div>
    <div class="absolute bottom-0 left-0 space-x-4 bg-white w-full px-4 py-2 box-border z-50 border-t border-solid border-gray-200">
      <el-button v-has="['c-base-mp-pound-system-config-save']" size="small" type="primary" @click="onSave">保 存</el-button>
      <el-button v-has="['c-base-mp-pound-system-config-push']" size="small" @click="onPush">推送地磅</el-button>
      <el-button size="small" @click="loadData">刷 新</el-button>
    </div>
  </section>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      form: {
        id: "",
        name: "",
        host: "",
        userpass: "",
        userid: "",
        remark: "",
        update_by_name: "",
        update_time: 0
      },
      rules: {
        name: [{ required: true, message: "请输入配置名称", trigger: "blur" }]
      }
    };
  },
  methods: {
    // 查询当前基地地磅系统配置并回显。
    async loadData() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/query_company_pound_system_config"
        });
        // 关键步骤：逐个字段赋值，确保 Vue 2 响应式正常工作。
        const data = (dataObj.data && dataObj.data.data) || {};
        this.form.id = data.id || "";
        this.form.name = data.name || "";
        this.form.host = data.host || "";
        this.form.userpass = data.userpass || "";
        this.form.userid = data.userid || "";
        this.form.remark = data.remark || "";
        this.form.update_by_name = data.update_by_name || "";
        this.form.update_time = data.update_time || 0;
      } catch (error) {}
    },
    // 保存当前基地地磅系统配置。
    onSave() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        this.$confirm("确认保存地磅系统配置?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          try {
            const form = { ...this.form };
            if (this.isMaskedSecret(form.userpass)) {
              form.userpass = "";
            }
            await this.$common.http({
              url: "/api/queue/admin/save_company_pound_system_config",
              data: form
            });
            this.$message.success("保存成功！");
            this.loadData();
          } catch (error) {}
        });
      });
    },
    // 输入预约单号测试推送地磅接口。
    async onPush() {
      try {
        const promptResult = await this.$prompt("请输入预约单号", "推送地磅", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入预约单号",
          inputValidator: value => {
            if (!String(value || "").trim()) {
              return "请输入预约单号";
            }
            return true;
          }
        });
        const booking_code = String((promptResult && promptResult.value) || "").trim();
        if (!booking_code) {
          return;
        }
        await this.$common.http({
          url: "/api/queue/admin/push_company_pound_system_booking",
          data: {
            booking_code
          }
        });
        this.$message.success("推送完成！");
      } catch (error) {}
    },
    // 判断是否为脱敏密钥占位值。
    isMaskedSecret(value) {
      return typeof value === "string" && value.indexOf("****") !== -1;
    },
    // 格式化时间戳。
    formatTime(timestamp) {
      if (!timestamp || Number(timestamp) <= 1) return "-";
      return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-input__validateIcon {
  display: none;
}
</style>
